import { configureStore } from "@reduxjs/toolkit";
import rootSaga from "./features";
import createSagaMiddleware from "redux-saga";
import conversationsReducer from "./features/conversations/conversationsSlice";
import userReducer from "./features/user/userSlice";
import adminReducer from "./features/admin/adminSlice";
import workspacesReducer from "./features/workspaces/workspacesSlice";
import globalActionReducer from "./features/globalAction/globalActionSlice";

const sagaMiddleware = createSagaMiddleware();
const store = configureStore({
    reducer: {
        conversations: conversationsReducer,
        user: userReducer,
        admin: adminReducer,
        workspaces: workspacesReducer,
        globalAction: globalActionReducer,
    },
    middleware: (getDefaultMiddleware) => [
        ...getDefaultMiddleware({
            serializableCheck: false,
        }),
        sagaMiddleware
    ],
});

sagaMiddleware.run(rootSaga);

export default store;
